<template>
	<div v-if="noItems">
		<h2 class="checkout-warning">It looks like your cart is empty 😕</h2>
		<h2 class="checkout-warning">Please add some items {{ itemIcon }}</h2>
		<h2 class="has-text-centered">
			<a aria-label="view menu" @click="_navigateToHome" class="full-width tp-link">
				<b>View Menu</b>
			</a>
		</h2>
	</div>
</template>
<script>
	import cartMixin from '@Mixin/cartMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	export default {
		mixins: [cartMixin, navigationMixin],
		computed: {
			itemIcon() {
				const appConstants = this.$appConstants;
				return appConstants.checkout.icons.foodType;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.checkout-warning {
		margin: 1em;
		font-weight: bold;
		font-size: 1.2em;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/EmptyCart.vue